function parseExpiryDays(expires) {
  if (typeof expires === 'number' && Number.isFinite(expires)) {
    return expires
  }

  if (typeof expires === 'string') {
    const match = expires.trim().match(/^(\d+)(d)?$/i)
    if (match) {
      return Number(match[1])
    }
  }

  return 7
}

export function getCookieValue(name) {
  if (typeof document === 'undefined' || !name) return ''

  const encodedName = encodeURIComponent(name)
  const cookies = document.cookie ? document.cookie.split('; ') : []

  for (const cookie of cookies) {
    const separatorIndex = cookie.indexOf('=')
    const key = separatorIndex >= 0 ? cookie.slice(0, separatorIndex) : cookie
    if (key === encodedName) {
      const value = separatorIndex >= 0 ? cookie.slice(separatorIndex + 1) : ''
      return decodeURIComponent(value)
    }
  }

  return ''
}

export function setCookieValue(name, value, expires = 7) {
  if (typeof document === 'undefined' || !name) return

  const days = parseExpiryDays(expires)
  const expiresAt = new Date(Date.now() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value ?? '')}; expires=${expiresAt.toUTCString()}; path=/; SameSite=Lax`
}

export function removeCookieValue(name) {
  if (typeof document === 'undefined' || !name) return
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`
}